import { money, fmtDate } from "@/lib/format";

export const STATUS = [["", "All"], ["full", "Paid in full"], ["partial", "Partially paid"], ["none", "Not started"]];
export const statusOf = (m) => (m.paid <= 0 ? "none" : m.paid >= m.goal ? "full" : "partial");
export const NOF = { q: "", church: "", status: "" };

export function filterMembers(members, f) {
  const q = f.q.trim().toLowerCase();
  return members.filter((m) => (!q || m.name.toLowerCase().includes(q)) && (!f.church || m.church_name === f.church) && (!f.status || statusOf(m) === f.status));
}

export function filterText(f) {
  const parts = [f.church && `Church: ${f.church}`, f.q.trim() && `Name contains: "${f.q.trim()}"`, f.status && `Status: ${STATUS.find(([k]) => k === f.status)[1]}`].filter(Boolean);
  return parts.length ? `Showing: ${parts.join(" · ")}` : "Showing: All churches and people";
}

const sum = (list, k) => Math.round(list.reduce((a, m) => a + m[k], 0) * 100) / 100;

export function specialSections(view, members) {
  if (view === "details") {
    return [{
      title: "Details",
      head: ["Name", "Church", "Goal", "Payments", "Paid", "Balance"],
      body: members.map((m) => [m.name, m.church_name, m.goal, m.payments.map((p) => `${money(p.amount)} (${fmtDate(p.date)})`).join("\n") || "—", m.paid, m.balance]),
      foot: [`TOTAL (${members.length} people)`, "", sum(members, "goal"), `${members.reduce((a, m) => a + m.payments.length, 0)} payment(s)`, sum(members, "paid"), sum(members, "balance")],
      moneyCols: [2, 4, 5],
    }];
  }
  const groups = Object.entries(members.reduce((g, m) => ({ ...g, [m.church_name]: [...(g[m.church_name] || []), m] }), {})).sort(([a], [b]) => a.localeCompare(b));
  return [
    { title: "Totals", head: ["Total goals", "Total paid", "Total balance"], body: [[sum(members, "goal"), sum(members, "paid"), sum(members, "balance")]], moneyCols: [0, 1, 2] },
    {
      title: "Totals by church",
      head: ["Church", "People", "Goal", "Paid", "Balance"],
      body: groups.map(([c, l]) => [c, l.length, sum(l, "goal"), sum(l, "paid"), sum(l, "balance")]),
      foot: ["TOTAL", members.length, sum(members, "goal"), sum(members, "paid"), sum(members, "balance")],
      moneyCols: [2, 3, 4],
    },
  ];
}
